import _ from "lodash";

const CveRetencOptions = [{
  label: 'Selecciona',
  value: ''
}].concat(_.sortBy([
  {
    label: 'Servicios profesionales. (01)',
    value: '01'
  },
  {
    label: 'Regalías por derechos de autor. (02)',
    value: '02'
  },
  {
    label: 'Autotransporte terrestre de carga. (03)',
    value: '03'
  },
  {
    label: 'Servicios prestados por comisionistas. (04)',
    value: '04'
  },
  {
    label: 'Arrendamiento. (05)',
    value: '05'
  },
  {
    label: 'Enajenación de acciones. (06)',
    value: '06'
  },
  {
    label: 'Enajenación de bienes objeto de la LIEPS, a través de mediadores, agentes, representantes, corredores, consignatarios o distribuidores. (07)',
    value: '07'
  },
  {
    label: 'Enajenación de bienes inmuebles consignada en escritura pública. (08)',
    value: '08'
  },
  {
    label: 'Enajenación de otros bienes, no consignada en escritura pública. (09)',
    value: '09'
  },
  {
    label: 'Adquisición de desperdicios industriales. (10)',
    value: '10'
  },
  {
    label: 'Adquisición de bienes consignada en escritura pública. (11)',
    value: '11'
  },
  {
    label: 'Adquisición de otros bienes, no consignada en escritura pública. (12)',
    value: '12'
  },
  {
    label: 'Otros retiros de AFORE. (13)',
    value: '13'
  },
  {
    label: 'Dividendos o utilidades distribuidas. (14)',
    value: '14'
  },
  {
    label: 'Remanente distribuible. (15)',
    value: '15'
  },
  {
    label: 'Intereses. (16)',
    value: '16'
  },
  {
    label: 'Arrendamiento en fideicomiso. (17)',
    value: '17'
  },
  {
    label: 'Pagos realizados a favor de residentes en el extranjero. (18)',
    value: '18'
  },
  {
    label: 'Enajenación de acciones u operaciones en bolsa de valores. (19)',
    value: '19'
  },
  {
    label: 'Obtención de premios. (20)',
    value: '20'
  },
  {
    label: 'Fideicomisos que no realizan actividades empresariales. (21)',
    value: '21'
  },
  {
    label: 'Planes personales de retiro. (22)',
    value: '22'
  },
  {
    label: 'Intereses reales deducibles por créditos hipotecarios. (23)',
    value: '23'
  },
  {
    label: 'Operaciones Financieras Derivadas de Capital. (24)',
    value: '24'
  },
  {
    label: 'Otro tipo de retenciones. (25)',
    value: '25'
  },
  {
    label: 'Servicios mediante Plataformas Tecnológicas. (26)',
    value: '26'
  },
  {
    label: 'Sector Financiero. (27)',
    value: '27'
  },
  {
    label: 'Pagos y retenciones a Contribuyentes del RIF. (28)',
    value: '28'
  }
], 'label'));

export default CveRetencOptions;